<script setup>
defineProps({
  url: {
    type: String,
    default: undefined,
  },

  pageType: {
    type: String,
    default: undefined,
  },
});
const { t } = useI18n();
</script>

<template>
  <CLocalizedLink class="cards-train-all" :to="url">
    <div class="cards-train-all__text">
      <span class="cards-train-all__font">
        {{ t(`wiki.pages.showAll.${pageType}`) }}
      </span>

      <div class="cards-train-all__arrow">
        <CIcon class="cards-train-all__icon" name="chevron-right" />
      </div>
    </div>
  </CLocalizedLink>
</template>

<style scoped lang="scss">
.cards-train-all {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: $color-main-5;
  border-radius: em(10);

  &__font {
    font-size: em(16);
  }

  &__icon {
    @include box(em(16));
  }

  &__text {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 em(20) em(14) em(14);
    margin-top: auto;
    color: $color-white;
  }

  &__arrow {
    @include box(em(30));

    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    background-color: $color-second-1;
    border-radius: 50%;
  }
}
</style>
